import __request__ from "routing/request";
export function showLicenses(requestOptions) {
  return __request__("GET", "/plugins/org.graylog.plugins.license/licenses", null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function deleteLicense(license_id, contract_id, requestOptions) {
  return __request__("DELETE", "/plugins/org.graylog.plugins.license/licenses", null, { "license_id": license_id, "contract_id": contract_id }, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function uploadLicense(license, requestOptions) {
  return __request__("POST", "/plugins/org.graylog.plugins.license/licenses", license, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function getEventDefinitions(requestOptions) {
  return __request__("GET", "/plugins/org.graylog.plugins.license/licenses/event-definitions", null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function getMetrics(requestOptions) {
  return __request__("GET", "/plugins/org.graylog.plugins.license/licenses/metrics", null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function showStatus(only_legacy = false, requestOptions) {
  return __request__("GET", "/plugins/org.graylog.plugins.license/licenses/status", null, { "only_legacy": only_legacy }, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function showStatusActive(requestOptions) {
  return __request__("GET", "/plugins/org.graylog.plugins.license/licenses/status/active", null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function statusForSubject(subject, bypass_cache = false, requestOptions) {
  return __request__("GET", "/plugins/org.graylog.plugins.license/licenses/status/for-subject", null, { "subject": subject, "bypass_cache": bypass_cache }, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function showStatusPaginated(sort = "expiration_date", page = 1, per_page = 50, query, filters, order = "asc", requestOptions) {
  return __request__("GET", "/plugins/org.graylog.plugins.license/licenses/status/paginated", null, { "page": page, "per_page": per_page, "query": query, "filters": filters, "sort": sort, "order": order }, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function getTrafficLimitViolations(requestOptions) {
  return __request__("GET", "/plugins/org.graylog.plugins.license/licenses/traffic-limit-violations", null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function acknowledgeTrafficLimitViolations(requestOptions) {
  return __request__("PUT", "/plugins/org.graylog.plugins.license/licenses/traffic-limit-violations/acknowledgement", null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function putTrafficLimitViolationSettings(settings, requestOptions) {
  return __request__("PUT", "/plugins/org.graylog.plugins.license/licenses/traffic-limit-violations/settings", settings, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function getTrafficLimitViolationSettings(requestOptions) {
  return __request__("GET", "/plugins/org.graylog.plugins.license/licenses/traffic-limit-violations/settings", null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function getRemaining(days = 30, includeToday = true, requestOptions) {
  return __request__("GET", "/plugins/org.graylog.plugins.license/licenses/traffic-remaining", null, { "days": days, "includeToday": includeToday }, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function getTrafficThreshold(requestOptions) {
  return __request__("GET", "/plugins/org.graylog.plugins.license/licenses/traffic-threshold", null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function acknowledgeTrafficThreshold(requestOptions) {
  return __request__("PUT", "/plugins/org.graylog.plugins.license/licenses/traffic-threshold/acknowledgement", null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function validityForSubject(subject, bypass_cache = false, requestOptions) {
  return __request__("GET", "/plugins/org.graylog.plugins.license/licenses/validity/for-subject", null, { "subject": subject, "bypass_cache": bypass_cache }, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function verifyLicense(license, requestOptions) {
  return __request__("POST", "/plugins/org.graylog.plugins.license/licenses/verify", license, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function showLicense(licenseId, requestOptions) {
  return __request__("GET", `/plugins/org.graylog.plugins.license/licenses/${licenseId}`, null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
